import React, { createRef } from "react";

import {
    Input,
    Row, Col,
    Card,
    CardBody,
    FormGroup,
    Button,

} from "reactstrap";
import GsuiteAuth from '../../components/Auth/GsuiteAuth';
//import ReactTable from "react-table-legacy";
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip';
import _ from 'underscore';
import PropTypes from 'prop-types';
import {BasicTable} from './Table'

const propTypes = {
    pageChangeFunc: PropTypes.func,
    limitChangeFunc: PropTypes.func,
}

export default class OriginalTable extends React.Component {
    constructor(props) {
        super(props);
        
        this.allCheckRef = createRef();

        this.state = this.addAllCheckField({
            default_column: this.props.column ? this.props.column : [],
            column: this.props.column ? this.props.column : [],
            data: this.props.data ? this.props.data : [],
            column_select_area_visible: false,
            tmp_column: [],
            detail_search: false,
            with_all_check: this.props.with_all_check ? this.props.with_all_check : false,
            all_check: this.props.all_check? this.props.all_check:false,
            change_all_check_flg: this.props.change_all_check_flg? this.props.change_all_check_flg:false,
            mode: this.props.mode ? this.props.mode : 0, // 0: その他大勢 1: 調査詳細モード
            perPage: this.props.perPage? this.props.perPage:50,
            sortOptions:this.props.defaultSortedColumn?this.props.defaultSortedColumn:[],
            count: this.props.count? this.props.count:0,
            perPage_options:this.props.perPage_options?this.props.perPage_options:[5,10,20,25,50,100],
            pageIndex: this.props.pageIndex? this.props.pageIndex: 0,
            checkedItems: this.props.checkedItems? this.props.checkedItems: [],
            unique_key: this.props.unique_key? this.props.unique_key: "",
            reloaded:false
        });
        //console.log(this.state);
        // this.addAllCheckField = this.addAllCheckField.bind(this);
        this.handleColumnChange = this.handleColumnChange.bind(this);
        this.setReactTableColumn = this.setReactTableColumn.bind(this);
        this.allCheckChanged = this.allCheckChanged.bind(this);
        this.updateChecked = this.updateChecked.bind(this);
        this.targettedDefaultColumn = this.targettedDefaultColumn.bind(this);
        this.detail_search_field_view = this.detail_search_field_view.bind(this);

        /* 2021/06/08 scroll to list top */
        this.currentRef = createRef();

        /* 2021/06/18 out of 1000 limit */        
        this.validPageNum = this.validPageNum.bind(this);
        this.addViewColumn = this.addViewColumn.bind(this);
    }

    // #1198
    addViewColumn () {
        let localStrageColumns;

        if (localStrageColumns = GsuiteAuth.get("all_column__" + this.props.page_id)) {
            const parseColumns = JSON.parse(localStrageColumns);
//            console.log(parseColumns);
            let ret = this.state.default_column.filter((col)=>{
                let matches = parseColumns.filter(parse_col=>parse_col.accessor == col.accessor);
//                console.log(matches);
                if ( matches.length == 0 ) {
//                    console.log(col);
                    return col;
                }
            });
//            console.log(ret);
            if (ret.length > 0) {
//                console.log(this.state.default_column)
                GsuiteAuth.set("all_column__" + this.props.page_id,JSON.stringify(this.state.default_column));
            }
            return ret;
        }
        else {
            GsuiteAuth.set("all_column__" + this.props.page_id,JSON.stringify(this.state.default_column));
            return this.state.default_column.filter((col)=>col.add_flg == true);
        }
    }

    UNSAFE_componentWillMount() {
        const column = this.state.default_column.map((data) => {
            if(data.defaultView === true){
                return data;
            }else if(data.defaultView === undefined){
                data.show = true;
                return data;
            }else{
                data.show = false;
                return data;
            }
        });
        
        if ( this.props.count != this.state.count ) {
            this.setState({count:this.props.count});
        }

        let addColumns = this.addViewColumn();
//        console.log(addColumns);


        const stringSavedColumn = GsuiteAuth.get(this.props.page_id)
        const jsonSavedColumn = (addColumns.length>0)? JSON.parse(stringSavedColumn).concat(addColumns) : JSON.parse(stringSavedColumn)
        const filteredColumn = jsonSavedColumn && jsonSavedColumn.filter((column)=>column.accessor != 'check')

//        console.log(jsonSavedColumn);
        this.setState({
            column: column,
            tmp_column:(this.props.page_id&&stringSavedColumn)
                ?(this.state.with_all_check
                    ?[
                        ...filteredColumn
                    ]
                    :jsonSavedColumn)
                :column
        }, ()=>this.setReactTableColumn())
    }

/*  既存ソース
    UNSAFE_componentWillMount() {
        const column = this.state.default_column.map((data) => {
            if(data.defaultView === true){
                return data;
            }else if(data.defaultView === undefined){
                data.show = true;
                return data;
            }else{
                data.show = false;
                return data;
            }
        });
        
        if ( this.props.count != this.state.count ) {
            this.setState({count:this.props.count});
        }

        const stringSavedColumn = GsuiteAuth.get(this.props.page_id)
        const jsonSavedColumn = JSON.parse(stringSavedColumn)
        const filteredColumn = jsonSavedColumn && jsonSavedColumn.filter((column)=>column.accessor != 'check')
        this.setState({
            column: column,
            tmp_column:(this.props.page_id&&stringSavedColumn)
                ?(this.state.with_all_check
                    ?[
                        ...filteredColumn
                    ]
                    :jsonSavedColumn)
                :column
        }, ()=>this.setReactTableColumn())
    }
*/
    
    addAllCheckField(state) {
//        console.log("addAllCheckField",state.all_check);
//        console.log("addAllCheckField",this.props.all_check);

        const checkColumn = { Header: <input type="checkbox" name="all_check" ref={this.allCheckRef} defaultChecked={this.props.all_check} onChange={(e) => { this.allCheckChanged(e) }} />, headerLabel: '□', accessor: 'check', sortable: false, width:50,minWidth:50,headerClassName: "text-center", className: "text-center", nonTargetFilter: true, allCheckField: true };

        return {
            ...state,
            ...{column: (state.with_all_check && !state.column.find(col=>col.accessor=="check")? [checkColumn,...state.column] : state.column)},
            ...{default_column: (state.with_all_check? [...state.default_column] : state.default_column)}
        }
    }

    allCheckChanged(e) {
        console.log("allCheckChanged",e.target.checked);
        let data = _.map(this.state.data, (item) => {
            item.checked = e.target.checked;
            return item;
        });

//        this.allCheckChanged.target.checked=e.target.checked;
//        this.setState({ all_check: true, data: data }, () => { this.props.checkedChangeCallback && this.props.checkedChangeCallback(data) });
        this.setState({ all_check: e.target.checked, data: data}, () => { this.props.checkedChangeCallback && this.props.checkedChangeCallback(data, this.state.all_check) });
    }

    componentDidMount(){
        // let ps;
        // let tables = document.querySelectorAll(".rt-table");
        // for (let i = 0; i < tables.length; i++) {0
        //     ps = new PerfectScrollbar(tables[i]);
        // }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ( this.props.count != this.state.count && !isNaN(this.props.count)) {
            this.setState({count: this.props.count });
        }


        if ( this.props.pageIndex != this.state.pageIndex && !isNaN(this.props.pageIndex )) {
            this.setState({pageIndex: this.props.pageIndex });
        }
        
//        console.log("prevProps",prevProps.all_check,"prevState",prevState.all_check);
//        console.log("props checked",this.props.all_check,"state checked",this.state.all_check);

        if (JSON.stringify(this.props.data) === JSON.stringify(prevProps.data))
            return;

        this.setState(this.addAllCheckField({
            ...this.state,
            data:this.props.data
        }));

        if (this.allCheckRef.current) {
            if ( this.props.all_check != this.allCheckRef.current.checked ) {
                this.allCheckRef.current.checked = this.props.all_check;
            }
        }
    }

    

    targettedDefaultColumn() {
        return this.state.default_column.filter((item) => { return !item.nonTargetFilter; });
    }

    //テーブル定義用
    handleColumnChange(e) {
        var column = [];

        _.each(this.state.default_column, (item) => {
            if(item.nonTargetFilter) {
                column.push(item);
            }
        });
        let targetted_default_column = this.targettedDefaultColumn();
        _.each(e.target, (item) => {
            if (!item.nonTargetFilter && item.selected) {
                column.push(targetted_default_column[item.value]);
            }
        });
        this.setState({ tmp_column: column });

    }

    getComparableValue(props){
        const tagRegex = /(<([^>]+)>)/ig
        if (props.dangerouslySetInnerHTML){
            return props.dangerouslySetInnerHTML.__html.replace(tagRegex,'')
        } else if (props.children) {
            return props.children.props ? props.children.props.defaultValue: props.children
        } else {
            return props.value
        }
    }

    setReactTableColumn(e) {
        const sortMethod = (a, b) => {
            const valueA = (a && (a.props?this.getComparableValue(a.props):a)) || ""
            const valueB = (b && (b.props?this.getComparableValue(b.props):b)) || ""
            return valueA >= valueB ? 1 : -1;
        }
        const t_column = this.state.tmp_column.map((item) => {
            item.show=true
            const columnData = this.state.default_column.find(element=>element.accessor == item.accessor)
            return {
                ...item,
                ...columnData,
                ...columnData&&(columnData.sortMethod?{}:{sortMethod})
            }
        });
        const checkColumn = { Header: <input type="checkbox" name="all_check" ref={this.allCheckRef} defaultChecked={this.state.all_check} onChange={(e) => { this.allCheckChanged(e) }} />, headerLabel: '□', accessor: 'check', sortable: false, width:50,minWidth:50,headerClassName: "text-center", className: "text-center", nonTargetFilter: true, allCheckField: true };
        this.setState({ column: (this.state.with_all_check && !t_column.find(col=>col.accessor=="check")? [checkColumn,...t_column] : t_column)});
        GsuiteAuth.set(this.props.page_id, JSON.stringify(this.state.tmp_column))
    }

    updateChecked(e, idx) {
        let data = _.map(this.state.data, (element, index, array) => {
            if (idx === index) {
                element.checked = e.target.checked;
            }
            return element;
        });
        this.setState({ data: data }, this.props.checkedChangeCallback && this.props.checkedChangeCallback(data, e.target.checked));
    }

    columnSelectArea() {
        if (this.state.mode === 1)
            return (<></>);
        else
            return (
                <>
                    <Row>
                        {this.detail_search_btn()}
                        <Col md="2">
                            <ButtonWithTooltip
                                onclick={() => { this.setState({ column_select_area_visible: !this.state.column_select_area_visible }); }}
                                class=""
                                id="tmp"
                                icon="fas fa-angle-down"
                                label="表示設定"
                                message="テーブルの表示設定を変更出来ます。"
                            />
                        </Col>
                    </Row>
                    <br />
                    {this.detail_search_field_view()}
                    <Row className={this.state.column_select_area_visible ? 'on' : 'off'}>
                        <Col md="12" className="margin-auto">
                            <Card>
                                <CardBody className={"search-box"}>
                                    <Row>
                                        <Col md="5">
                                            <FormGroup>
                                                <Input type="select" name="column" id="column" onChange={this.handleColumnChange} multiple={true}>
                                                    {this.targettedDefaultColumn().map((data, index) => (
                                                        <option key={index} value={index}>{data.headerLabel ? data.headerLabel : data.Header}</option>
                                                    ))}
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                        <Col md="3">
                                            <Button type="button" color="default" onClick={this.setReactTableColumn}>反映</Button>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </>
            );
    }
    detail_search_btn(){
        // return this.props.detail_search_field
        // console.log('detail_search_field', this.props.detail_search_field)
        if(this.props.detail_search_field){
            return (<>
            <Col md="2">
                <div id="detailed-search-button">
                <ButtonWithTooltip
                    onclick={() => { this.setState({ detail_search: !this.state.detail_search }); }} 
                    class="" 
                    id="detail" 
                    icon="fas fa-angle-down" 
                    label="詳細検索" 
                    message="詳細検索を表示します。" />
                </div>
            </Col>        
            </>);
        }
    }
    detail_search_field_view(){

        if(this.state.detail_search){
            
            return (<>
                <Row className={this.state.detail_search ? 'on' : 'off'}>
                    <Col md="12" className="margin-auto">
                        <Card>
                            <CardBody className={"search-box"}>
                            <Row>
                            {this.props.detail_search_field_cols}
                            </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>   
            </>);     
        }
    }

    syncData () {
        return this.state.data;
    }

    validPageNum ( pageNum ) {
        var setPageIndex = Number(pageNum) - 1;
        var pageCount = Math.ceil(this.state.count / this.state.perPage);
        if (setPageIndex < 0) {
            setPageIndex = 0;
        }
        else if (pageCount <= setPageIndex) {
            setPageIndex = pageCount - 1;
            if(setPageIndex < 0){
                setPageIndex = 0;
            }
        }
        return setPageIndex;
    }

    // チェック済みアイテム取得
    getChecked() {
        return this.state.data.filter((item) => {
            return item.checked;
        });
    }

    render() {
        let data = (this.state.with_all_check?this.state.data.map((element, index) => {
            var check;
            var item = element[this.state.unique_key];

            if ( this.state.checkedItems.length > 0) {
                var base_id, checked_id;
                switch ( this.state.unique_key ) {
                    case "INVOICE__estimate_natural_id":{
                        base_id = item.props["children"];
                        checked_id = this.state.checkedItems.find(item=>item[this.state.unique_key].props["children"] == base_id);
                    }break;
                    case "estimate_natural_id_ssv":
                    case "SECURITY_DEPOSIT__estimate_natural_id":{
                        base_id = item;
                        checked_id = this.state.checkedItems.find(item=>item[this.state.unique_key] == base_id);
                    }break;
                }
               
                check = <input type="checkbox" name="item_check" checked={element.checked === true || checked_id != undefined} onChange={(e) => { this.updateChecked(e, index) }} />
            }
            else {
                check = <input type="checkbox" name="item_check" checked={element.checked === true} onChange={(e) => { this.updateChecked(e, index) }} />
            }
            return {
                ...element,
                check
            }
        }):this.state.data)
        
        let columnSelectArea = this.columnSelectArea();

        return (
            <>
                <CardBody>
                    {columnSelectArea}
                    {this.props.checkbox_field_cols}
                    <br/>
                    <span ref={this.currentRef}></span>
                    <BasicTable
                        columns={this.state.column}
                        data={data}
                        onClickRow={(idx, row) => {
                            (this.props.clickRowCallback) && this.props.clickRowCallback(this.state.data[idx]);
                        }}
                    />
                    {/* <ReactTable
                        page={0}
                        manualPagination={true}
                        sortable={true}
                        sorted={this.state.sortOptions}
                        onSortedChange={val => {
                            this.setState({ sortOptions: val }) }
                        }
                        data={data}
                        columns={this.state.column}
                        defaultPageSize={100}
                        minRows={3}
                        filterable={false}
                        showPaginationTop={false}
                        showPaginationBottom={false}
                        rowsText="件表示"
                        loadingText='読込中…'
                        noDataText=''
                        pageText=''
                        ofText='/'
                        className="-highlight primary-pagination"
                        getTdProps={(state, rowInfo, column, instance) => {
                            return {
                                onClick: (e, handleOriginal) => {
                                    (this.props.clickRowCallback && rowInfo && rowInfo.index !== undefined) && this.props.clickRowCallback(this.state.data[rowInfo.index]);

                                    // IMPORTANT! React-Table uses onClick internally to trigger
                                    // events like expanding SubComponents and pivots.
                                    // By default a custom 'onClick' handler will override this functionality.
                                    // If you want to fire the original onClick handler, call the
                                    // 'handleOriginal' function.
                                    if (handleOriginal) {
                                        handleOriginal()
                                    }
                                }
                            }
                        }}
                    /> */}
                </CardBody>
            </>
        );
    }
}
OriginalTable.propTypes = propTypes;